import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GetCarousel {
    getCarousel {
      id
      title
      subtext
      ctaText
      ctaResource
      position
      textColor
      backgroundImage
      logo
      ctaType
    }
  }
`

export const getCarouselKey = getQueryNames(query)[0]

export default query
